import validate from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import bank_45redirect_45global from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/middleware/bankRedirect.global.ts";
import set_45middleware_45global from "/Users/cofidisdigital/Documents/repositories/credito-nuxt/middleware/setMiddleware.global.ts";
export const globalMiddleware = [
  validate,
  bank_45redirect_45global,
  set_45middleware_45global
]
export const namedMiddleware = {
  auth: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/middleware/auth.ts"),
  "precompiled-access": () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/middleware/precompiledAccess.ts"),
  redirect: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/middleware/redirect.ts"),
  resume: () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/middleware/resume.ts"),
  "set-crm-parameters": () => import("/Users/cofidisdigital/Documents/repositories/credito-nuxt/middleware/setCrmParameters.ts")
}